import { ValueModel } from '@zajno/common-mobx/viewModels';
import { reaction } from 'mobx';

const DEFAULT_NOTIFICATION_TIME = 5000;

export enum NotificationTypes {
    default = 'default',
    error = 'error',
}

type Notification = {
    title: string,
    type: NotificationTypes,
};

export class NotificationsViewModel {
    private readonly _notifications = new ValueModel<Notification[]>([], true);

    constructor() {
        reaction(
            () => this._notifications.value,
            value => {
                if (value.length) {
                    setTimeout(() => {
                        const newArr = [...this._notifications.value];
                        newArr.shift();

                        this._notifications.setValue(newArr);
                    }, DEFAULT_NOTIFICATION_TIME);
                }

            },
        );
    }
    public get listOfNotifications() { return this._notifications.value; }

    public setNotification = (title: string, type: NotificationTypes = NotificationTypes.default) => {
        if (title.length) {
            const newArr = [...this._notifications.value];
            newArr.push({ title, type });

            this._notifications.setValue(newArr);
        }
    };
}
